import isAlliancePolicy from "./Checkers/isAlliancePolicy";
import getAllianceMessage from "./Getters/getAllianceMessage";

export default function parseCoveragesInTable(products, groups, showProcessId) {
  let properties = {};
  const idValAgre = getValoAgreId(groups);

  for (const [idx, product] of products.entries()) {
    let otrval = [];

    for (const [_, coverage] of product.coverages.entries()) {
      //! No mostrar coverages con view_status 0
      if (coverage.view_status === "0" || coverage.view_status === 0) {
        continue;
      }
      //! Agregar coverages a Valor Diferencial
      if (coverage.group_id === idValAgre || coverage.group_id === false) {
        otrval.push(coverage.description_tag + ": " + coverage.description);
        continue;
      }
      if (!properties[coverage.group_id]) {
        properties[coverage.group_id] = {};
      }
      if (!properties[coverage.group_id][coverage.description_tag]) {
        properties[coverage.group_id][coverage.description_tag] = {
          //!Descomentar cuando cada coverage tenga su priority
          priority: coverage.priority,
        };
      }
      properties[coverage.group_id][coverage.description_tag][idx] =
        coverage.description;
    }
    //! Añadir Valor Diferencial
    if (!properties[idValAgre]) properties[idValAgre] = {};
    if (!properties[idValAgre]["Valor Diferencial"])
      properties[idValAgre]["Valor Diferencial"] = {};

    //! Añadir mensaje de alianza
    isAlliancePolicy(product.policy_provider) &&
      otrval.push(getAllianceMessage(product.policy_provider));

    if (otrval.length > 0)
      properties[idValAgre]["Valor Diferencial"][idx] = otrval;

    //! Añadir numero de proceso
    showProcessId && otrval.push("Numero de proceso: " + product.process_id);
  }

  //! groups to array and sort it
  const sortable = parseAndSortGroups(groups);

  //! array of rows to send to the table
  return parsePropertiesToArray(properties, sortable);
}

function parseAndSortGroups(groups) {
  let sortable = [];
  for (var group in groups) {
    sortable.push(groups[group]);
  }

  sortable.sort(function (x, y) {
    return x.priority - y.priority;
  });
  return sortable;
}

function parsePropertiesToArray(properties, sortable) {
  let arraRes = [];
  for (const group of sortable) {
    const group_name = group["group"];
    const group_id = group["group_id"];

    if (!properties[group_id]) continue;

    arraRes.push({
      name: group_name,
      type: "group",
    });

    //! sort coverages inside a group
    const arrayOfCoverages = sortCoveragesInGroup(properties[group_id]);

    arraRes = [...arraRes, ...arrayOfCoverages];
  }
  // console.log(arraRes);
  return arraRes;
}

function sortCoveragesInGroup(propertiesObj) {
  let coveragesSorted = [];

  for (const coverage in propertiesObj) {
    coveragesSorted.push({
      name: coverage,
      ...propertiesObj[coverage],
    });
  }

  //! Descomentar cuando cada coverage tenga su priority
  coveragesSorted.sort((x, y) => x.priority - y.priority);

  return coveragesSorted;
}

function getValoAgreId(groups) {
  for (const group in groups) {
    if (groups[group].group === "Valor Diferencial") {
      return groups[group].group_id;
    }
  }
  return false;
}
